import router from "./index.js"
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = 'DOTA东泰医疗-' + to.meta.title;
    } else {
        document.title = 'DOTA东泰医疗'
    }
    next()
})